import { render, staticRenderFns } from "./pay-order-list.vue?vue&type=template&id=64cfa005&scoped=true"
import script from "./pay-order-list.vue?vue&type=script&lang=ts"
export * from "./pay-order-list.vue?vue&type=script&lang=ts"
import style0 from "./pay-order-list.vue?vue&type=style&index=0&id=64cfa005&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cfa005",
  null
  
)

export default component.exports